import { formatPercentage } from "../helper/formatPercentage";

export default function PercentageValue({ value, minimumFractionDigits = 0, maximumFractionDigits = 3, className = "" }) {
  const formatted = formatPercentage(value, { minimumFractionDigits, maximumFractionDigits });
  if (formatted === "-") return <span className={className}>-</span>;
  const isNegative = formatted.startsWith("-");
  const unsigned = isNegative ? formatted.slice(1) : formatted;
  const number = unsigned.slice(0, -1);
  return (
    <span dir="ltr" aria-label={formatted} className={`inline-flex items-baseline [direction:ltr] ${className}`}>
      {isNegative && <span aria-hidden="true">-</span>}
      <span aria-hidden="true">{number}</span>
      <span aria-hidden="true">%</span>
    </span>
  );
}
